import styled from 'styled-components';

// Styled components for Role Management page
export const ForbiddenWrapper = styled.div`
  text-align: center;
  padding: 50px;
`;

export const ModulesContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
  border: 1px solid #e2e8ee;
  border-radius: 8px;
  padding: 16px;
`;

export const ModuleItem = styled.div`
  margin-bottom: 24px;
`;

export const ModuleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f4f6f9;
  border-radius: 8px;
  margin-bottom: 12px;
`;

export const ModuleName = styled.span`
  font-weight: 600;
`;

export const SubModuleItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
`;

export const SubModuleName = styled.span`
  font-size: 14px;
`;

export const EmptyModulesMessage = styled.div`
  text-align: center;
  padding: 20px;
  color: #999;
`;

